document.addEventListener("DOMContentLoaded", function() {

    document.body.addEventListener("click", function(event) {
        if (event.target.classList.contains("vk-prod-accordion")) {

            var clickedAccordion = event.target;
            clickedAccordion.classList.toggle("active");

            // Traverse to find the related panel from the clicked accordion
            var panel = clickedAccordion.nextElementSibling.querySelector('.vk-prod-panel');

            if (panel) {
                panel.classList.toggle("active");

                // Toggle the display style for the panel content
                if (panel.classList.contains("active")) {
                    panel.style.display = "block";
                } else {
                    panel.style.display = "none";
                }
            }
        }
    });
});
